/**
 * @desc 创建盘点任务
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.InventoryTaskCreateDto>, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/createInevntoryTask`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
